import {
  STATUS_REJECTED,
  STATUS_REJECTED_MANAGER,
  STATUS_VOID,
  STATUS_DRAFT,
  STATUS_SUBMITTED,
  STATUS_OPEN,
  STATUS_ANSWERED,
  STATUS_ANSWERED_MANAGER,
  STATUS_CLOSED,
} from './status-types';
import { ISSUE_ATTRIBUTE_NAMES } from './issue-attribute-names';

export const SHOW_TOAST_STATUS_LIST = [
  STATUS_VOID,
  STATUS_DRAFT,
  STATUS_SUBMITTED,
  STATUS_OPEN,
  STATUS_ANSWERED,
  STATUS_REJECTED,
  STATUS_CLOSED,
  STATUS_REJECTED_MANAGER,
  STATUS_ANSWERED_MANAGER,
];

export const FE_TRANSITION_FIELDS = {
  INFO: 'info',
  CREATE_REVISION: 'createRevision',
};

export const BE_TRANSITION_KEYS = {
  RFI_TRANSITION_CLOSED: 'RFI_TRANSITION_CLOSED', // Draft (creator) > Submitted
  RFI_TRANSITION_CLOSED_V2: 'closed', // Draft (creator) > Submitted
  RFI_TRANSITION_SC_GC_SUBMIT: 'RFI_TRANSITION_SC_GC_SUBMIT', // Draft (creator) > Submitted
  RFI_TRANSITION_SC_GC_SUBMIT_V2: 'submitted',
  RFI_TRANSITION_SC_SC_CLOSE: 'RFI_TRANSITION_SC_SC_CLOSE',
  RFI_TRANSITION_SC_SC_VOID: 'RFI_TRANSITION_SC_SC_VOID',
  RFI_TRANSITION_GC_SC_CLOSE: 'RFI_TRANSITION_GC_SC_CLOSE',
  RFI_TRANSITION_GC_GC_CLOSE: 'RFI_TRANSITION_GC_GC_CLOSE',
  RFI_TRANSITION_VOID: 'void', // v2
  RFI_TRANSITION_GC_GC_VOID: 'RFI_TRANSITION_GC_GC_VOID',
  RFI_TRANSITION_GC_SC_VOID: 'RFI_TRANSITION_GC_SC_VOID',
  RFI_TRANSITION_GC_CM_OPEN: 'RFI_TRANSITION_GC_CM_OPEN', // workflow B - Draft (manager) > open, Submitted > open
  RFI_TRANSITION_GC_ARCH_OPEN: 'RFI_TRANSITION_GC_ARCH_OPEN', // workflow A - Draft (manager) > open, Submitted > open
  RFI_TRANSITION_GC_ARCH_OPEN_V2: 'open', // workflow A - Draft (manager) > open, Submitted > open
  RFI_TRANSITION_GC_ARCH_OPEN_REV1: 'openRev1', // workflow B - Draft (manager) > open, Submitted > open
  RFI_TRANSITION_GC_ARCH_OPEN_REV2: 'openRev2', // workflow B - Draft (manager) > open, Submitted > open
  RFI_TRANSITION_CM_GC_ANSWER: 'RFI_TRANSITION_CM_GC_ANSWER', // workflow B - rev A > manager (without rev B)
  RFI_TRANSITION_CM_GC_ANSWER_V2: 'answeredManager', // workflow B - rev A > manager (without rev B)
  RFI_TRANSITION_CM_GC_REJECT: 'RFI_TRANSITION_CM_GC_REJECT', // workflow B - rev A > manager (without rev B)
  RFI_TRANSITION_CM_GC_REJECT_V2: 'rejectedManager', // workflow B - rev A > manager (without rev B)
  RFI_TRANSITION_CM_GC_FORWARD: 'RFI_TRANSITION_CM_GC_FORWARD', // workflow B - Rev A > manager (after rev B)
  RFI_TRANSITION_CM_ARCH_FORWARD: 'RFI_TRANSITION_CM_ARCH_FORWARD', // workflow B - Rev A > rev B
  RFI_TRANSITION_CM_GC_VOID: 'RFI_TRANSITION_CM_GC_VOID',
  RFI_TRANSITION_CM_SC_VOID: 'RFI_TRANSITION_CM_SC_VOID',
  RFI_TRANSITION_ARCH_CM_ANSWER: 'RFI_TRANSITION_ARCH_CM_ANSWER', // workflow B - Rev B > Rev A
  RFI_TRANSITION_ARCH_CM_ANSWER_V2: 'answeredRev1', // workflow B - Rev B > Rev A
  RFI_TRANSITION_ARCH_CM_REJECT: 'RFI_TRANSITION_ARCH_CM_REJECT', // workflow B - Rev B > Rev A
  RFI_TRANSITION_ARCH_CM_REJECT_V2: 'rejectedRev1', // workflow B - Rev B > Rev A
  RFI_TRANSITION_ARCH_GC_VOID: 'RFI_TRANSITION_ARCH_GC_VOID',
  RFI_TRANSITION_ARCH_SC_VOID: 'RFI_TRANSITION_ARCH_SC_VOID',
  RFI_TRANSITION_ARCH_GC_ANSWER: 'RFI_TRANSITION_ARCH_GC_ANSWER', // workflow A - Open - Answered
  RFI_TRANSITION_ARCH_GC_REJECT: 'RFI_TRANSITION_ARCH_GC_REJECT', // workflow A - Open - Rejected,
  RFI_TRANSITION_ARCH_GC_ANSWER_V2: 'answered', // workflow A - Open - Answered
  RFI_TRANSITION_ARCH_GC_REJECT_V2: 'rejected', // workflow A - Open - Rejected,
  RFI_TRANSITION_GC_ARCH_REOPEN: 'RFI_TRANSITION_GC_ARCH_REOPEN', // workflow A - Reopen
  RFI_TRANSITION_GC_ARCH_REOPEN_REV2: 'RFI_TRANSITION_GC_ARCH_REOPEN_REV2', // workflow B - Reopen to reviewer 2
  RFI_TRANSITION_SUBMITTED: 'submitted', // Draft -> Submitted
};

export const CLOSED_TRANSITION_KEYS = [
  BE_TRANSITION_KEYS.RFI_TRANSITION_CLOSED_V2,
  BE_TRANSITION_KEYS.RFI_TRANSITION_CLOSED,
  BE_TRANSITION_KEYS.RFI_TRANSITION_SC_SC_CLOSE,
  BE_TRANSITION_KEYS.RFI_TRANSITION_GC_SC_CLOSE,
  BE_TRANSITION_KEYS.RFI_TRANSITION_GC_GC_CLOSE,
];

export const VOID_TRANSITION_KEYS = [
  BE_TRANSITION_KEYS.RFI_TRANSITION_VOID,
  BE_TRANSITION_KEYS.RFI_TRANSITION_SC_SC_VOID,
  BE_TRANSITION_KEYS.RFI_TRANSITION_GC_GC_VOID,
  BE_TRANSITION_KEYS.RFI_TRANSITION_GC_SC_VOID,
  BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_VOID,
  BE_TRANSITION_KEYS.RFI_TRANSITION_CM_SC_VOID,
  BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_VOID,
  BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_SC_VOID,
];

export const FORWARD_TRANSITION_KEYS = [
  BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_FORWARD,
  BE_TRANSITION_KEYS.RFI_TRANSITION_CM_ARCH_FORWARD,
  BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV2,
];

export const ANSWER_TRANSITION_KEYS = [
  BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_ANSWER,
  BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER,
  BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_ANSWER,
  BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_ANSWER_V2,
  BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER_V2,
];

export const CALL_TO_ACTION_LABEL_TRANSLATION_KEYS = {
  CLOSED_TRANSITION: 'callToAction.rfis.label.closeAndDistribute',
  REOPEN_TRANSITION: 'callToAction.rfis.label.reopen',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CLOSED]: 'callToAction.rfis.label.closeAndDistribute',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CLOSED_V2]: 'callToAction.rfis.label.closeAndDistribute',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_SC_GC_SUBMIT]: 'callToAction.rfis.label.submitToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_SC_GC_SUBMIT_V2]: 'callToAction.rfis.label.submitToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_FORWARD]: 'callToAction.rfis.label.submitToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN]: 'callToAction.rfis.label.submitToReviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_V2]: 'callToAction.rfis.label.submitToReviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV1]: 'callToAction.rfis.label.submitToReviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_CM_OPEN]: 'callToAction.rfis.label.submitToReviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_ARCH_FORWARD]: 'callToAction.rfis.label.forwardToReviewer2',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV2]:
    'callToAction.rfis.label.forwardToReviewer2',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_ANSWER]:
    'callToAction.rfis.label.submitOfficialResponse',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_ANSWER_V2]:
    'callToAction.rfis.label.submitOfficialResponse',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_REJECT_V2]:
    'callToAction.rfis.label.submitOfficialResponse',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER_V2]:
    'callToAction.rfis.label.submitOfficialResponse',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER]:
    'callToAction.rfis.label.submitOfficialResponse',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_ANSWER]:
    'callToAction.rfis.label.submitOfficialResponse',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_ANSWER_V2]:
    'callToAction.rfis.label.submitOfficialResponse',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_REOPEN]: 'callToAction.rfis.label.returnToReviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_REOPEN_REV2]:
    'callToAction.rfis.label.returnToReviewer2',
};

export const TRANSITION_SAVE_BUTTON_TRANSLATION_KEYS = {
  CLOSED_TRANSITION: 'transition.buttonText.closeRfi',
  VOID_TRANSITION: 'transition.buttonText.void',
  REOPEN_TRANSITION: 'transition.buttonText.reopenButtonText',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_SC_GC_SUBMIT]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_CM_OPEN]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_V2]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV1]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV2]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_ANSWER]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_ANSWER_V2]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_REJECT]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_REJECT_V2]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_ANSWER]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER_V2]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_REJECT]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_REJECT_V2]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_REJECT]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_FORWARD]: 'transition.buttonText.submit',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_ARCH_FORWARD]: 'transition.buttonText.forward',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_REOPEN]: 'transition.buttonText.reopen',
};

export const ASSIGN_TO_TRANSLATION_KEYS = {
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN]: 'transition.assignTo.reviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_CM_OPEN]: 'transition.assignTo.reviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_V2]: 'transition.assignTo.reviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV1]: 'transition.assignTo.reviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_ARCH_FORWARD]: 'transition.assignTo.reviewer2',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV2]: 'transition.assignTo.reviewer2',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_SC_GC_SUBMIT]: 'transition.assignTo.manager',
};

export const INFO_TRANSLATION_KEYS = {
  CLOSED_TRANSITION: 'transition.infoText.rfis.closed',
  VOID_TRANSITION: 'transition.infoText.rfis.void',
  REOPEN_TRANSITION: 'transition.infoText.rfis.reopen',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN]: 'transition.infoText.rfis.submitToReviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_V2]: 'transition.infoText.rfis.submitToReviewer', // open
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV1]:
    'transition.infoText.rfis.submitToReviewer', // openRev1
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_ANSWER]:
    'transition.infoText.rfis.submitResponseToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_REJECT]:
    'transition.infoText.rfis.submitResponseToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_ANSWER]:
    'transition.infoText.rfis.submitResponseToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_ANSWER_V2]:
    'transition.infoText.rfis.submitResponseToManager', // answered
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_REJECT]:
    'transition.infoText.rfis.submitResponseToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_GC_REJECT_V2]:
    'transition.infoText.rfis.submitResponseToManager', // rejected
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_FORWARD]: 'transition.infoText.rfis.submitRfiToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_OPEN_REV2]: 'transition.infoText.rfis.openReviewer2', // openRev2
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER]:
    'transition.infoText.rfis.submitResponseToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_ANSWER_V2]:
    'transition.infoText.rfis.submitResponseToReviewer1', // answeredRev1
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_REJECT]:
    'transition.infoText.rfis.submitResponseToManager',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_ARCH_CM_REJECT_V2]:
    'transition.infoText.rfis.submitResponseToReviewer1', // rejectedRev1
  [BE_TRANSITION_KEYS.RFI_TRANSITION_GC_ARCH_REOPEN]: 'transition.infoText.rfis.returnToReviewer',
  [BE_TRANSITION_KEYS.RFI_TRANSITION_SUBMITTED]: 'transition.infoText.rfis.submitRfiToManager', // submitted
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_ANSWER_V2]:
    'transition.infoText.rfis.submitResponseToManager', // answeredManager
  [BE_TRANSITION_KEYS.RFI_TRANSITION_CM_GC_REJECT_V2]:
    'transition.infoText.rfis.submitResponseToManager', // rejectedManager
};

// Void transition is done in header status dropdown. Reject transition is done as status change in answered transition.
export const IGNORED_CALL_TO_ACTION_TRANSITION_STATUSES = [STATUS_VOID, STATUS_REJECTED];
export const IGNORED_CALL_TO_ACTION_TRANSITION_STATUSES_REJECTED_RFI = [
  STATUS_VOID,
  STATUS_ANSWERED,
];

export const RFI_VOID_TRANSITION_FIELDS = [
  {
    fieldName: ISSUE_ATTRIBUTE_NAMES.COMMENTS_ATTRIBUTES,
    isMandatory: false,
  },
  {
    fieldName: FE_TRANSITION_FIELDS.INFO,
    translationKey: INFO_TRANSLATION_KEYS.VOID_TRANSITION,
  },
];
